import { GetState, ThunkDispatch } from '../../generalTypes';
import constants from '../../settings/constants';
import { selectCurrentView } from '../navigation/navigationSelectors';
import { actionSetSceneRect } from '../scene';
import { thunkSetMargins, thunkSetMinRoom } from '../scene/sceneThunks';

export const thunkSetupDerivedDefaultState =
  () => (dispatch: ThunkDispatch, getState: GetState) => {
    const currentView = selectCurrentView(getState());
    if (currentView === constants.VIEW_NAMES.SUMMARY) {
      dispatch(actionSetSceneRect({ x: 0, y: 56, width: 789, height: 492 }));
    }
    dispatch(thunkSetMinRoom());
    dispatch(thunkSetMargins());
  };
